import React, { useEffect, useState } from "react";
import UserService from "services/UserService";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";


function EngagementPoint() {
  const [showModal, setShowModal] = useState(false);
  const [rank, setRank] = useState(0);
  const { team } = useTeamContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        var allResponses = await Promise.all([
          UserService.getUserProfile(),
          TeamService.getNetThrivingScoreStats(team?.id),
        ]);
        setRank(allResponses[1].data.data.rank);
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();
  }, [team.id]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  function calculateProgressWidth() {
    const points = rank?.points || 0;
    if (points <= 50) {
      return (points / 50) * 100;
    } else if (points <= 200) {
      return ((points - 50) / 150) * 100;
    } else if (points <= 500) {
      return ((points - 200) / 300) * 100;
    } else if (points <= 1000) {
      return ((points - 500) / 500) * 100;
    } else {
      return 100;
    }
  }
  const styles = {
    loaderStyle: {
      display: "flex",
      justifyContent: "center",
    },
  };
  const classes = styles;

  const LoadingContainer = (
    <>
      {loading && (
        <h4 style={{ display: "flex", justifyContent: "center" }}>
          <Loader loaderStyle={classes.LoaderStyle} />
        </h4>
      )}
    </>
  );


  const closeIcon = (
    <Button type="button" buttonClass="btn-close modalClose2">
      <CloseIcon onClick={toggleModal} />
    </Button>
  );

  return (
    <>
      {loading ? (
        LoadingContainer
      ) : (
        <div className="netThrivingHeaderRooot">
          <div className="yellowBox">
            <span>Team Engagement Points</span>
            <div className="whiteBox">
              <div className="netThrivingContent">
                <div className="netThrivingLeftContent">
                <Modal
                  open={showModal}
                  onClose={toggleModal}
                  center
                  closeIcon={closeIcon}
                  styles={{
                    modal: {
                      width: "320px",
                    },
                  }}
                >
                  <h5>
                    <strong>Earn QR-points by:</strong>
                  </h5>
                  <ul>
                    <li>Respond to a Post</li>
                    <li>Initiate a Check In</li>
                    <li>Respond to a Check In</li>
                    <li>Create a Trivia</li>
                    <li>Complete a Trivia Answer</li>
                    <li>Use the ReTeam AI Assistant</li>
                    <li>Create a Thank You</li>
                    <li>Be Recognized in a Thank you</li>
                    <li>Initiate a Slideshow</li>
                    <li>Respond to a Slideshow</li>
                    <li>Initiate a Team Video</li>
                    <li>Respond in Video to a Team Video</li>
                    <li>Create a New Idea</li>
                    <li>Post Idea to Innovation Vista</li>
                    <li>Create a Survey</li>
                    <li>Respond to a Survey</li>
                    <li>Create a Poll</li>
                    <li>Respond to a Poll</li>
                    <li>Respond to a Riddle of the Day</li>
                  </ul>
                </Modal>
                  {rank && (
                    <div class="progress-bar-container">
                      <div class="progress-bar">
                        <div class="progress-bar-inner">
                          <div
                            class="progress-bar-fill"
                            style={{ width: `${calculateProgressWidth()}%` }}
                          >
                            <span className="progress-bar-text">
                              {rank?.points} Pts
                            </span>
                          </div>
                        </div>
                      </div>
                      <span class="progress-label left-label">
                        {rank?.min_points} Pts
                      </span>
                      <span class="progress-label right-label">
                        {rank?.max_points} Pts
                      </span>
                    </div>
                  )}
                  <div className="earnPoints">
                    <button
                      className="btn btn-primary btn-sm mt-3 yellow-button"
                      onClick={toggleModal}
                    >
                      Earn Points
                    </button>
                  </div>
                </div>
                <div className="netThrivingRightContent">
                  <div className="happinessContent">
                    <div className="circleRooot">
                      <img
                        className="circleAnimation"
                        src={rank?.icon}
                        alt="loading..."
                      />
                    </div>
                    {/* <span className="">{rank?.name}</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EngagementPoint;
